import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaFileAlt } from "react-icons/fa";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import { FaBuilding } from 'react-icons/fa';
import { MdMiscellaneousServices } from 'react-icons/md';
import { IoMdContacts } from 'react-icons/io';




export default function WebFooter() {


  return (
    <>
      <Col lg={12}>
        <div className='footer-section p-1 pt-4'>
          <Container>
            <Row className='mt-3'>
              <Col lg={4}  >
                <h5 className='fw-bold'><FaBuilding className='me-2' /> Pradh Management Solutions</h5>
                <p >
                  Pradh Management Solutions delivers professional industrial and commercial services including cleaning, maintenance, MEP, construction, and manpower solutions. Trusted for quality, safety, and timely execution across sectors.
                </p>


              </Col>

              <Col lg={5}>

                <Row  style={{fontSize:'15px'}}>
                  <Col xs={6}>
                    <h5 className='fw-bold'><MdMiscellaneousServices className='me-2' /> Quick Links</h5>
                    <ul className="list-unstyled">
                      <li><a href="/" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Home</a></li>
                      <li><a href="/aboutus" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> About</a></li>
                      <li><a href="/contact" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Contact</a></li>
                      <li><a href="/manpowerandhousekeeping" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Manpower Services</a></li>
                      <li><a href="/fabricationservices" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Fabrication Services</a></li>
                    </ul>
                  </Col>
                  <Col xs={6}>
                    <h5 className='fw-bold'><MdMiscellaneousServices className='me-2' /> Services</h5>
                    <ul className="list-unstyled">
                      <li><a href="/cleaningservices" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Cleaning Services</a></li>
                      <li><a href="/maintenanceservice" className="   text-white text-decoration-none"><RiArrowRightDoubleLine /> Maintenance Services</a></li>
                      <li><a href="/civilconstructionser" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Civil & Construction</a></li>
                      <li><a href="/mepservice" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> MEP Services</a></li>
                      <li><a href="/paintingandcoating" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Painting & Coating</a></li>
                      <li><a href="/pestbirdcontrol" className="text-white text-decoration-none"><RiArrowRightDoubleLine /> Pest & Bird Control</a></li>
                    </ul>
                  </Col>
                </Row>
              </Col>


              <Col lg={3} >
                <h5 className='fw-bold'><IoMdContacts className='me-2' /> Connect With us</h5>

                <div  >
                  <FaLocationDot /> REGUS, 6th Floor Pentagon P-2, Magarpatta City, Hadapsar, Pune, Maharashtra, India 13
                </div>
                <div className=' '>
                  <a
                    href="https://wa.me/8482922662 "
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span >
                      <FaMobileAlt />  +918482922662
                    </span>
                  </a>
                </div>

                <div className='d-flex '>
                  <a
                    href="mailto:pradhmspl@gmail.com "
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span >
                      < MdEmail />  pradhmspl@gmail.com
                    </span>
                  </a>
                </div>

                <div className='d-flex mt-2 '>

                  <a className='iconback' href="#">
                    <FaFacebookF />
                  </a>
                  <a className='iconback mx-2' href='#'>
                    <IoLogoYoutube />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaInstagram />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaXTwitter />
                  </a>
                </div>
              </Col>
            </Row>

            <div className=' mt-3 footerend text-center' style={{ color: 'white' }}>
              <hr />
              <p >© {new Date().getFullYear()} <span className='fw-bold'>Pradh Management Solutions</span>  |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  )
}
